export const EXPERIMENT_TYPE_GL = 'geolift';
export const EXPERIMENT_TYPE_GL_EXTERNAL = 'geolift_external';

export const GEO_LIFT_CATEGORY_LABEL = 'Geo Lift';

export interface GeoLiftExperimentLabels {
  typeLabel: string;
  categoryDotColorKey: 'inPlatform' | 'external';
}

export function getGeoLiftExperimentLabels(experimentType: string): GeoLiftExperimentLabels {
  if (experimentType === EXPERIMENT_TYPE_GL_EXTERNAL) {
    return {
      typeLabel: 'External experiment',
      categoryDotColorKey: 'external',
    };
  }
  return {
    typeLabel: 'In-platform design',
    categoryDotColorKey: 'inPlatform',
  };
}

export function formatExperimentCreatedDate(createdAt: string): string {
  return new Date(createdAt).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

const METHODOLOGY_LABELS: Record<string, string> = {
  mmt: 'Matched Markets',
  sc: 'Synthetic Control',
};

export function getMethodologyLabel(methodologyType: string | null | undefined): string | null {
  if (!methodologyType) return null;
  return METHODOLOGY_LABELS[methodologyType] ?? methodologyType;
}
